// QR Kiosk v2 — §8.5 bot-body wrapper. Splits a bot message into an ordered block
// list from wire order alone (imported PURE splitMarkerBlocks — the pinned cross-
// team [Step:] grammar MANDATES import, never re-implement) and renders each block
// as either a settled progress chip (marker) or token-styled markdown. §5a ref-tag
// rewrite runs FIRST (markers are plain text by contract → one pass is safe). The
// responsive table→cards switch is a className toggle via useBreakpoint (CSS in
// kiosk-v2-tokens.css §1.5). Streaming holds back half-streamed marker AND ref-tag
// tails so neither flashes as prose.
import React from "react";
import { splitMarkerBlocks, holdPartialMarkerTail } from "../../../customer/midas/components/v3/markerBlocksV3";
import { useBreakpoint } from "../../../shared/hooks/useBreakpoint";
import { rewriteKioskRefs, holdPartialRefTagTail } from "./kioskRefTags";
import { MidasMarkdown } from "./midasMarkdown";
import { MidasStepChip } from "./MidasStepChip";

export interface MidasBotBodyProps {
  text: string;
  streaming?: boolean;
  isLoading?: boolean;
}

export function MidasBotBody({ text, streaming, isLoading }: MidasBotBodyProps) {
  const { isPhone } = useBreakpoint();

  // While streaming, hold back a partial marker line AND a partial ref tag so
  // neither `[Step: Sea` nor `<list-re` ever flashes as prose (§5a/§8.5).
  let safe = text;
  if (streaming) {
    safe = holdPartialMarkerTail(text).safe;
    safe = holdPartialRefTagTail(safe).safe;
  }
  const blocks = splitMarkerBlocks(rewriteKioskRefs(safe));

  return (
    <div className={isPhone ? "kv2-md kv2-md--stack" : "kv2-md"}>
      {blocks.map((b, i) =>
        b.kind === "marker" ? (
          <MidasStepChip key={i} label={b.label} live={!!streaming && !!isLoading && i === blocks.length - 1} />
        ) : (
          <MidasMarkdown key={i} text={b.text} />
        )
      )}
    </div>
  );
}

export default MidasBotBody;
